import { createAsyncThunk } from '@reduxjs/toolkit';

import { buildSpendInsightsBody } from '../lib/buildSpendInsightsBody';

import type {
    SpendInsightsRequestParams,
    SpendOvertimePointDto,
    SpendOvertimeResponseDto,
} from '../types/ReportSpendSummarySchema';
import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export interface FetchSpendOvertimeParams extends SpendInsightsRequestParams {
    period?: 'day' | 'week' | 'month';
}

export const fetchSpendOvertime = createAsyncThunk<
    SpendOvertimePointDto[],
    FetchSpendOvertimeParams,
    ThunkConfig<string>
>('reportSpendSummary/fetchSpendOvertime', async (params, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;
    try {
        const { period, ...filters } = params;
        const response = await extra.api.post<SpendOvertimeResponseDto>(
            '/v1/reports/spend-insights/overtime',
            buildSpendInsightsBody(
                filters,
                period
                    ? {
                          period,
                      }
                    : {},
            ),
        );
        return response.data?.items ?? [];
    } catch {
        return rejectWithValue('error');
    }
});
